import { render, staticRenderFns } from "./view_TermsAndConditions.vue?vue&type=template&id=062e8002&scoped=true&"
import script from "./view_TermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./view_TermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./view_TermsAndConditions.vue?vue&type=style&index=0&id=062e8002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062e8002",
  null
  
)

export default component.exports